import React, { useState, useEffect } from "react";
import BreakingNews from "./BreakingNews";
import QuizAnswer from "./QuizAnswer";

const QuizQuestion = (props) => {
  const [activePriceButton, setActivePriceButton] = useState({
    direction: "",
  });
  const [activeQuantityButton, setActiveQuantityButton] = useState({
    direction: "",
  });
  const {
    questionAnswer,
    submitted,
    answeredCorrectly,
    answeredPartialy,
    questionIndex,
    selectedOption,
    setSelectedOption,
  } = props;
  return (
    <BreakingNews
      questionAnswer={questionAnswer}
      submitted={submitted}
      answeredCorrectly={answeredCorrectly}
      answeredPartialy={answeredPartialy}
      questionIndex={questionIndex}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
    />
  );

  // return (
  //   <QuizAnswer
  //     questionAnswer={questionAnswer}
  //     moved={moved}
  //     isDemandMoved={isDemandMoved}
  //     isSupplyMoved={isSupplyMoved}
  //     supplyAnsweredCorrectly={supplyAnsweredCorrectly}
  //     demandAnsweredCorrectly={demandAnsweredCorrectly}
  //     showBriefness={answeredCorrectly ? false : true}
  //     secondStage={secondStage}
  //     nextStageSubmitted={nextStageSubmitted}
  //     activePriceButton={activePriceButton}
  //     markSecondQuestion={markSecondQuestion}
  //     activeQuantityButton={activeQuantityButton}
  //   />
  // );
};

export default QuizQuestion;
